import type { IconSvgObject } from './types';

const AirplaneTakeOff01Icon: IconSvgObject = [
  ["path", { d: "M2 19H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 13.5L2 8L4.5 6.5L6.5 9L13.5412 5.34038C15.1735 4.48683 17.0794 4.17159 18.7603 4.92643C19.6489 5.32553 20.6311 5.87707 21.4975 6.62005C22.4691 7.45319 21.9369 8.87248 20.7119 9.25281L15 11L14 13.5L9.5 15L10.5 12L4 13.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AirplaneTakeOff01Icon;
